import React from 'react';

import DashBoardTable from './Dashboard/DashboardTable';

const InformationMessage: React.FC = () => {
  return <DashBoardTable />;
};

export default InformationMessage;
